<template>
	<div class="lm-radio-group-wrap">
		<div class="lm-radio-group">
			<!-- https://getbootstrap.com/docs/3.4/css/#checkboxes-and-radios -->
			<!-- :for="`radio-${view_type}-${dbColName}-group-item-${index}`" -->
			<component :is="isInline ? 'label' : 'div'" v-for="(option, index) in mutableOptions" :class="[ isInline ? 'radio-inline' : 'radio' ]"
								 :key="`radio-${view_type}-${dbColName}-group-item-${index}`">
				<component :is="isInline ? 'div' : 'label'" >
					<input type="radio" v-model="model" :value="option" :disabled="is_disabled"/>
					<span v-html="getLabel(option)"></span>
				</component>
			</component>
		</div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
	import ctrlMixins from './_mixins'
	import { customTemplate, ctrlParamsForAll } from './_common-stuff.ts';

	export default {
    name: "CtrlRadioGroup",
		mixins: [ ctrlMixins ], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Группа радиобаттонов',
			params: {
				isPublishType: {
					name: 'Статус публикации', // 1 - обычный четырехзначный, 2 - двузначный
					editType: 'publishTypeEditor'
				},
				customTemplate,
				defaultValue: {
					name: 'Значение по умолчанию',
					tip: 'Указывается ID нужной записи. Применяется только в карточке и только при создании записи',
					editType: 'input'
				},
				isInline: {
					name: 'В линию',
					tip: 'Список элементов переключения будет отображаться в одну линию',
					editType: 'checkbox'
				},
				...ctrlParamsForAll,
			}
		},
		props: {
			// большая часть пропсов приезжает из ctrlMixins!
			/**
			 * Текущие выбранное значение
			 * @type {String||null}
			 */
			value: {
				default () {
					// параметр контрола defaultValue имеет более высокий приоритет
					// и применяется на более высоком уровне, тут речь только о ситуации когда ни значения ни defaultValue нет
					return this.view_type === 'filter' ? '' : null
				}
			},
			/**
			 * Ключ для навзения поля в option.
			 * @type {String}
			 */
			label: {
				type: String,
				default: 'name'
			},
			/**
			 * Возвращяем только значение option, а не сам обьект.
			 * Значение ключа, которое будем возвращять.
			 * @type {String}
			 */
			return: {
				type: String,
				default: 'id'
			},
			record_data: {
				type: Object
			}
		},
		data () {
			return {
				mutableValue: null,
				mutableOptions: []
			}
		},
		watch: {
			/**
			 * Когда изменлся props value
			 * меняем внутренний mutableValue.
			 * @param  {mixed} val
			 * @return {void}
			 */
			value (val) {
				this.mutableValue = val

				if (this.return) {
					const initialValueWithReturn = this.return && this.mutableOptions.find(o => o[this.return] === val)
					this.mutableValue = initialValueWithReturn || val
				}
			},
			/**
			 * Обновление списков
			 * @param  {mixed} val
			 * @return {void}
			 */
			options (val) {
				this.mutableOptions = val

				if (this.return) {
					const initialValueWithReturn = this.return && val.find(o => o[this.return] === this.value)
					this.mutableValue = initialValueWithReturn[this.return] || this.model
				}
			}
		},
		computed: {
			isFilter () {
				return (this.view_type === 'filter')
			},
			isRequired () {
				return !!this.field_meta.required
			},
			isPublishType () {
				return this.field_meta.ctrlParams.isPublishType
			},
			isInline () {
				return Boolean(this.field_meta.ctrlParams.isInline)
			},
			/**
			 * Выбранное значение в v-model
			 * @return {Object|String}
			 */
			model: {
				get () {
					return this.mutableValue
				},
				set (v) {
					if (this.return) {
						this.c_value = v[this.return]
						this.mixin_inputEvent()
						this.mixin_saveEvent()
						return this.$emit('input', v[this.return])
					}
				}
			},
			dbColName () {
				return this.field_meta.dbcolname
			}
		},
		created () {
			// TODO : Вынести данную логику за пределы дропдауна

			/** -- */
			if (this.isFilter) this.mutableOptions.push({ id: '', name: 'Все' })
			if (!this.isRequired) this.mutableOptions.push({ id: null, name: 'Не задано' })
			if (this.isRequired && this.is_new_record) this.mutableOptions.push({ id: null, name: 'Выберите значение' })

			if (this.isPublishType) {
				this.mutableOptions.push({ id: 4, name: 'Не опубликовано' })
				if (this.isPublishType !== 2) {
					this.mutableOptions.push({ id: 2, name: 'На внутреннем' })
					this.mutableOptions.push({ id: 1, name: 'На внешнем' })
				}

				this.mutableOptions.push({ id: 3, name: 'Везде' })
			} else this.mutableOptions = [ ...this.mutableOptions, ...this.c_srv_options ]

			/* -- */

			const initialValueWithReturn = this.return && this.mutableOptions.find(o => o[this.return] === this.value)

			this.mutableValue = initialValueWithReturn || null
		},
		mounted () {
			// при создании записи для статусов публикации без явно заданного умолчательного значения ставим Опубликован
			if (this.$props.is_new_record && this.c_ctrlParams.isPublishType && !this.c_ctrlParams.defaultValue) {
				this.c_value = 3;
				this.$emit('input', 3)
			}
		},
		methods: {
			/**
			 * Проверяем, выбранн ли option.
			 * @param  {Object|String} option
			 * @return Boolean
			 */
			isOptionSelected (option) {
				return (this.mutableValue === option)
			},
			getLabel (option) {
				if (typeof option === 'object' && this.label && !!option[this.label]) {
					return option[this.label]
				} else {
					const label = this.mutableOptions.find(i => i[this.return] === option)
					if (label) {
						return label[this.label]
					} else return option
				}
			}
		}
  }
</script>

<style scoped>

</style>
